// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigate-container[data-v-2de0095a]{background-color:var(--main-theme-color)}.wrap[data-v-2de0095a]{width:calc(var(--inner-width)*1px);margin:0 auto;justify-content:space-evenly}.item[data-v-2de0095a],.wrap[data-v-2de0095a]{display:flex}.item[data-v-2de0095a]{width:100%;min-width:200px;height:36px;justify-content:center;align-items:center;font-size:20px;color:#fff;font-weight:700}.is-active[data-v-2de0095a]{background-color:#fff;color:var(--main-theme-color)}", ""]);
// Exports
module.exports = exports;
